import { useState } from "react";
import LayoutActividad from "../../../components/LayoutActividad";
import ImagenGrupo from "../../../images/modulo1/grupo.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { modulo1 } from "../../../routes/Module1";
import Sidebar from "../Sidebar";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo1/Actividad1.mp3";

const Actividad1 = () => {
  const [answersText, setAnswersText] = useState({
    ans1: { value: "", valid: "", correctValue: "2" },
    ans2: { value: "", valid: "", correctValue: "2" },
    ans3: { value: "", valid: "", correctValue: "Brayan" },
    ans4: { value: "", valid: "", correctValue: "Richi" },
  });
  const infoUnidad = modulo1.content[0];
  const infoAct = modulo1.content[0].activities[0];
  const crumbs = [
    {
      title: modulo1.title,
      url: "/" + modulo1.url,
    },
    {
      title:
        modulo1.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo1.content[0].activities[1].name}`,
    linkNext: `${modulo1.url}/${modulo1.content[0].path}/${modulo1.content[0].activities[1].path}`,
    titlePrev: modulo1.title,
    linkPrev: modulo1.url,
  };
  const metadata = {
    color: modulo1.color,
    title: `${modulo1.title} - ${infoAct.name}`,
    name: modulo1.title
  };

  const handleAnswersText = (event, name) => {
    event.preventDefault();
    setAnswersText({
      ...answersText,
      [name]: { ...answersText[name], value: event.target.value },
    });
  };

  const validateAnswers = (event) => {
    event.preventDefault();
    let newAnswersText = answersText;
    Object.keys(newAnswersText).forEach(
      (key) =>
        (newAnswersText[key]["valid"] =
          answersText[key]["correctValue"].toUpperCase() ===
          answersText[key]["value"].toUpperCase()
            ? "is-valid"
            : "is-invalid")
    );
    setAnswersText({ ...newAnswersText });
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <div className="row">
        <div className="col-md-8">
          <p>
            <small className={`c-${modulo1.color} hat-text`}>
              <FontAwesomeIcon icon={faEye} /> Observamos
            </small>
          </p>
          <h2 className="mb-5">Actividad 1</h2>
          <AudioPlayer track={Audio} />

          <ul>
            <li>Todos somos diferentes.</li>
            <li>Observa a las personas y responde las preguntas.</li>
          </ul>
        </div>
      </div>
      <div className="row">
        <div className="col-md-9">
          <img src={ImagenGrupo} className="img-fluid" alt="Grupo" />
        </div>
        <div className="col-md-4">
          <p>¿Cuántas niñas hay?</p>
          <input
            type="text"
            className={
              "form-control mb-4 input-text-sm w-200 " + answersText.ans1.valid
            }
            value={answersText.ans1.value}
            onChange={(event) => handleAnswersText(event, "ans1")}
          />
          <p>¿Cuántos niños hay?</p>
          <input
            type="text"
            className={
              "form-control mb-4 input-text-sm w-200 " + answersText.ans2.valid
            }
            value={answersText.ans2.value}
            onChange={(event) => handleAnswersText(event, "ans2")}
          />
          <p>¿Quién es más alto: Brayan o Emilia?</p>
          <input
            type="text"
            className={
              "form-control mb-4 input-text-sm w-200 " + answersText.ans3.valid
            }
            value={answersText.ans3.value}
            onChange={(event) => handleAnswersText(event, "ans3")}
          />
          <p>¿Quién es mayor: Richi o Eli?</p>
          <input
            type="text"
            className={
              "form-control input-text-sm w-200 " + answersText.ans4.valid
            }
            value={answersText.ans4.value}
            onChange={(event) => handleAnswersText(event, "ans4")}
          />
        </div>
      </div>
      <div className="d-flex w-100 my-4">
        <button
          className={`btn btn-${modulo1.color}`}
          onClick={validateAnswers}
        >
          Enviar respuestas
        </button>
      </div>
      <GuiaDocente>
        <p>
          Lea las indicaciones. Observen las imágenes. Lea las preguntas y
          escuche atentamente las respuestas. Para finalizar, retome cada
          pregunta y su respuesta y resalte el hecho de que todos tenemos
          distintas características.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad1;
